import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled, { DefaultTheme } from "styled-components";

export const BillDetailsSubWrapper = styled.div(({ theme }) => ({
    padding: `0 ${theme.spacing.medium}`,
    borderRadius: theme.spacing.medium,
    border: "1px solid transparent",
    boxShadow: theme.elevation[theme.colorMode].skim.boxShadow,
    background: theme.colors[theme.colorMode].background_Primary,
}));

export const OrderIdText = styled(Text)(({ theme }) => ({
    marginBottom: theme.spacing.medium,
}));

export const BillDetailsWrapper = styled.div({
    position: "relative",
    zIndex: 2,
});

export const AddTip = styled.div(() => ({
    display: "flex",
}));

export const AddIcon = styled.div(({ theme }) => ({
    display: "flex",
    marginTop: theme.spacing.xxSmall,
}));

export const AddText = styled.div(({ theme }) => ({
    marginLeft: theme.spacing.xxSmall,
}));

export const ClearTip = styled.div(({ theme }) => ({
    marginLeft: theme.spacing.xSmall,
    color: "#9A9B9E",
}));

export const TipSuggestion = styled.div(({ theme }) => ({
    display: "flex",
    marginTop: theme.spacing.xSmall,
    justifyContent: "space-between",
}));

export const TipSection = styled.div(({ theme }) => ({
    paddingTop: theme.spacing.small,
    paddingBottom: theme.spacing.small,
}));

interface TipSuggestionItemProps {
    tabIndex: number;
    selectedTipIndex: number;
    theme: DefaultTheme;
}

const TIP_ITEM_WIDTH = "22.4%";
const TIP_ITEM_HEIGHT = 30;
const TIP_ITEM_MARGIN = 6;
const TIP_ITEM_BORDER_RADIUS = 10;

export const TipSuggestionitem = styled.div<TipSuggestionItemProps>(({ tabIndex, selectedTipIndex, theme }) => ({
    width: TIP_ITEM_WIDTH,
    height: TIP_ITEM_HEIGHT,
    margin: `${TIP_ITEM_MARGIN}px ${tabIndex === 3 ? 0 : TIP_ITEM_MARGIN}px`,
    padding: "10px 0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: TIP_ITEM_BORDER_RADIUS,
    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.08)",
    border: `1px solid ${
        selectedTipIndex === tabIndex
            ? theme.colors[theme.colorMode].primary
            : theme.colors[theme.colorMode].border_Secondary
    }`,
    backgroundColor: selectedTipIndex === tabIndex ? theme.colors[theme.colorMode].primary_Sub : "transparent",
}));

export const TipElement = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    gap: theme.spacing.empty,
}));

export const ChargeBottomSheet = styled.div(({ theme }) => ({
    padding: theme.spacing.large,
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
}));
export const TipContainer = styled.div(() => ({
    zIndex: 999,
}));
